import { createAuthClient } from "better-auth/react";
import { API_URL } from "./api";

/**
 * Better-Auth React client configured for Mami Tracker
 *
 * This client connects to the backend authentication endpoints
 * and provides authentication methods for the frontend.
 *
 * Uses VITE_API_URL environment variable for the backend URL.
 */
export const authClient = createAuthClient({
	baseURL: API_URL || "http://localhost:8787",
});
